import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchFooter } from '../../containers/common/commonSlice';

const ADOBE_LAUNCH_STAGE = 'https://assets.adobedtm.com/launch-EN553b171db06049cb9786c3a9bdebf7cf-staging.min.js';
//const ADOBE_LAUNCH_PROD = process.env.REACT_APP_ADOBE_LAUNCH_SRC;
function baseHost() {
  const h = window.location.hostname.toLowerCase();
  console.log('host=', h);
  if (h.includes("stage") || h.includes("localhost")) return ADOBE_LAUNCH_STAGE;
  return ADOBE_LAUNCH_PROD;
}

export const Footer = () => {
  const dispatch = useDispatch();
  const footerHTML = useSelector((state) => state.common.footerHTML);
  const footerRef = useRef(null);

  useEffect(() => {
    dispatch(fetchFooter());
  }, [dispatch]);

  // useEffect(() => {
  //   let ADOBE_LAUNCH_SRC = baseHost()
  //   if (!footerHTML || !footerRef.current) return;
  //   if (document.querySelector(`script[src="${ADOBE_LAUNCH_SRC}"]`)) return;
  //   const id = requestAnimationFrame(() => {
  //     const s = document.createElement('script');
  //     s.src = ADOBE_LAUNCH_SRC;
  //     s.async = true;
  //     s.defer = true;
  //     const nonce = document.querySelector('script[nonce]')?.getAttribute('nonce');
  //     if (nonce) s.setAttribute('nonce', nonce);
  //     document.head.appendChild(s);
  //   });
  //   return () => cancelAnimationFrame(id);
  // }, [footerHTML]);

  return (
    <>
      <div ref={footerRef} dangerouslySetInnerHTML={{ __html: footerHTML }} />
    </>
  );
};

export default Footer;
 